import React, { useState } from 'react';
import { Flex, Image, IconButton, Menu, Link } from '@chakra-ui/react';
import { HiOutlineDesktopComputer } from 'react-icons/hi'
import { AiOutlinePlusCircle } from 'react-icons/ai'
import { BsBoxArrowInDownRight, BsBoxArrowInUpLeft } from 'react-icons/bs'
import NavItem from '../NavItem';
import logomca from '../../../img-docs/logomca.svg'
import logomacapequenta from '../../../img-docs/logoMcaPequena.png'
import SubNavItem from '../SubNavItem';
import { FaRegFileAlt, FaUsers } from "react-icons/fa";
import { FaArrowsDownToPeople } from "react-icons/fa6";
import { RiBankFill } from "react-icons/ri";
import { Link as ReactLink } from 'react-router-dom';
import { Permission, criancaFunc } from "../../../helpers/Funcionalidades";
import { useAuthProvider } from '../../../Context/AuthProvider';


export default function Sidebar(props) {
    const [navSize, setNavSize] = useState("large")
    const { roleKeycloack } = useAuthProvider();

    return (
        <Flex
            h="100vh"
            display={props.display ? props.display : ["none", "none", "flex", "flex"]}
            flexDirection="column"
            justifyItems={"center"}
            justifyContent="space-between"
            w={navSize === "small" ? 90 : 300}
            overflow={"auto"}
            backgroundColor="#006064"
            id={"sidebar"}
            data-testid="sidebar"
        >

            <Flex h={"100%"} w="auto">

                <Flex
                    w={"100%"}
                    flexDir="column"
                    alignItems={navSize === "small" ? "center" : "flex-start"}
                    justifyContent={"space-between"}
                >

                    <Flex flexDir={"column"} minW={navSize === "small" ? "85px" : "100%"}>
                        {navSize === "small" ? (
                            <Link alignSelf="center"
                                as={ReactLink}
                                to={"/"}>
                                <Image w={50} src={logomacapequenta} rounded="10px" ml={1} mt={5} mb={8} />
                            </Link>
                        ) : (
                            <Link alignSelf="center"
                                as={ReactLink}
                                to={"/"}>
                                <Image w={200} src={logomca} mt={5} mb={8} />
                            </Link>
                        )}

                        <Flex flexDir={"column"}  >
                            <NavItem
                                navSize={navSize}
                                href="/dashboard"
                                icon={HiOutlineDesktopComputer}
                                title="Dashboard"
                                active={props.categoria === "Dashboard"}
                                onClick={() => { sessionStorage.clear(); }}
                            />
                            <NavItem
                                navSize={navSize}
                                href="/servico-acolhimento"
                                icon={RiBankFill}
                                title="Serviços de Acolhimento"
                                active={props.categoria === "Serviços de Acolhimento"}
                                onClick={() => { sessionStorage.clear(); }}
                            />
                            <NavItem
                                navSize={navSize}
                                href="/crianca"
                                icon={FaUsers}
                                title="Crianças e Adolescentes"
                                active={props.categoria === "Crianças e Adolescentes"}
                                onClick={() => { sessionStorage.clear(); }}
                            />
                            <NavItem
                                navSize={navSize}
                                href="/visitas/lista"
                                icon={FaArrowsDownToPeople}
                                title="Agenda de Visitas"
                                active={props.categoria === "Visita"}
                                onClick={() => { sessionStorage.clear(); }}
                            />

                            <NavItem
                                navSize={navSize}
                                href="/"
                                icon={FaRegFileAlt}
                                title="Relatórios"
                                active={props.categoria === "Relatórios"}
                                onClick={() => { sessionStorage.clear(); }}
                            />

                            <Permission
                                roleKeycloack={roleKeycloack}
                                func={criancaFunc.visualizarTudo}
                            >
                                <Menu>
                                    <NavItem
                                        href={"#"}
                                        navSize={navSize}
                                        icon={AiOutlinePlusCircle}
                                        title="Cadastros"
                                        isOpen={props.categoria === "Cadastros"}
                                        active={props.categoria === "Cadastros"}
                                    >

                                        <SubNavItem
                                            navSize={navSize}
                                            href="/tipo-servico-acolhimento/lista"
                                            title="Tipo de Serviço de Acolhimento"
                                            active={props.entidade === "Tipo de Serviço de Acolhimento"}
                                        />
                                        <SubNavItem
                                            navSize={navSize}
                                            href="/situacao-juridica/lista"
                                            title="Situação Jurídica"
                                            active={props.entidade === "Situação Jurídica"}
                                        />
                                        <SubNavItem
                                            navSize={navSize}
                                            href="/motivo-situacao/lista"
                                            title="Motivo de Situação"
                                            active={props.entidade === "Motivo de Situação"}
                                        />
                                        <SubNavItem
                                            navSize={navSize}
                                            href="/doenca/lista"
                                            title="Doença"
                                            active={props.entidade === "Doenças"}
                                        />

                                    </NavItem>
                                </Menu>
                            </Permission>
                        </Flex>
                    </Flex>

                    <IconButton
                        color={"white"}
                        background="none"
                        pb={2}
                        alignSelf={navSize === "small" ? "center" : "flex-end"}
                        size={40}
                        _hover={{ background: 'none' }}
                        icon={navSize === "small" ? <BsBoxArrowInDownRight size={40} color="#fff" /> : <BsBoxArrowInUpLeft size={40} color="#fff" />}
                        onClick={() => {
                            if (navSize === "small")
                                setNavSize("large")
                            else
                                setNavSize("small")
                        }}
                    />
                </Flex>


            </Flex>


        </Flex >

    )
};